import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useFolderTreeResponsive } from "@devowl-wp/react-folder-tree";
import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const APP_TREE_MOUNT_INHERIT_KEYS = [
    "id",
    "attachmentsBrowser",
    "isModal",
    "isSticky",
    "isStickyHeader",
    "isResizable",
    "isFullWidth",
    "style",
    "applyLayout",
    "isMobile"
];
const APP_TREE_MOUNT_SYMBOL = Symbol();
const useAppTreeMountContext = ()=>useImmutableContext(APP_TREE_MOUNT_SYMBOL);
function useAppTreeMountProvider(value) {
    return useImmutableContextProvider(APP_TREE_MOUNT_SYMBOL, value, {}, {
        inherit: [
            ...APP_TREE_MOUNT_INHERIT_KEYS
        ]
    });
}
const AppTreeMountProvider = ({ children, value })=>{
    const layout = useFolderTreeResponsive({
        isModal: value.isModal
    });
    const mountValue = useMemo(()=>({
            ...value,
            ...layout
        }), [
        value,
        layout.isSticky,
        layout.isStickyHeader,
        layout.isResizable,
        layout.isFullWidth,
        layout.style,
        layout.isMobile,
        layout.applyLayout
    ]);
    const [Provider, contextValue] = useAppTreeMountProvider(mountValue);
    return /*#__PURE__*/ _jsx(Provider, {
        value: contextValue,
        children: children
    });
};
export { AppTreeMountProvider, useAppTreeMountContext };
